
// Flag to ensure we only clear the cache once per session
let imageCacheCleared = false;

/**
 * Clear the image cache in the service worker, but only once per session
 * This is useful for ensuring we get fresh images after migrations
 */
export const clearImageCacheOnce = () => {
  if (!imageCacheCleared && navigator.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'CLEAR_IMAGE_CACHE'
    });
    imageCacheCleared = true;
    console.log('Service worker image cache cleared');
    
    // Return true to indicate success
    return true;
  }
  return false;
};

/**
 * Invalidate a specific image in the cache
 * @param url The URL of the image to invalidate
 */
export const invalidateImageCache = (url: string) => {
  if (navigator.serviceWorker?.controller && url) {
    navigator.serviceWorker.controller.postMessage({
      type: 'INVALIDATE_IMAGE_CACHE',
      url
    });
    console.log(`Invalidated cache for ${url}`);
    return true;
  }
  return false;
};

/**
 * Pre-cache an important image for faster loading
 * @param url The URL of the image to pre-cache
 */
export const preCacheImage = (url: string) => {
  if (navigator.serviceWorker?.controller && url) {
    navigator.serviceWorker.controller.postMessage({
      type: 'PRECACHE_IMAGE',
      url
    });
    console.log(`Pre-cached image: ${url}`);
    return true;
  }
  return false;
};

/**
 * Force reload an image with cache busting
 * @param url The URL of the image to reload
 * @returns The new URL with cache busting parameter
 */
export const getReloadedImageUrl = (url: string): string => {
  if (!url) return '';
  
  // Invalidate in service worker first
  invalidateImageCache(url);
  
  // Add cache busting parameter
  const timestamp = Date.now();
  return url.includes('?') ? `${url}&t=${timestamp}` : `${url}?t=${timestamp}`;
};
